module.exports = __webpack_public_path__ + "static/3-4479d2ae2e5fc7232bef746a239bf992.jpg";